module.exports = function() {
  return new Worker(__webpack_public_path__ + "72cb9d38de0236cae170.worker.js");
};